// @flow

import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import useProject from "../hooks/useProject";
import { PROJECTS } from "../locales/namespaces";
import Form from "./form/form";

type Props = {

};

const Create = (props: Props) => {
	const {t} = useTranslation(PROJECTS)
	let { projectId } = useParams()
	if (!projectId) {
		projectId = props.projectId
	}
	useEffect(() => {
		document.title = !projectId ? t('New Project') : t('Edit Project')
	}, [])
	
	const {loading, project,assignees,projectWorks} = useProject({projectId})
	
	return !loading &&(
		<Fragment>
			<Form
				projectId={projectId}
				project={project}
				assignees={assignees}
				projectWorks={projectWorks}
			/>
		</Fragment>
	)
};

export default Create